<template>
  <div class="app">
    <!-- 头 -->
    <Header></Header>
    <!-- 内容 -->
    <div class="father">
      <router-view></router-view>
    </div>
    <!-- 尾 -->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import Cookies from 'js-cookie'

export default {
  components: { Header, Footer },
  name: 'layout',
  data() {
    return {}
  },
  beforeRouteEnter(to, from, next) {
    // 执行顺序是 beforeRouteEnter → created → mounted →beforeRouteEnter的next
    // 不！能！获取组件实例 `this`
    // 因为当守卫执行前，组件实例还没被创建
    // next()
    next((vm) => {
      if (from.name === 'login') {
        vm.$router.go(0)
      }
    })
  }
}
</script>

<style>
.father {
  /* header+footer */
  min-height: calc(100vh - 125px - 34px);
}
</style>
